import { render } from "./CreateVersion.vue?vue&type=template&id=00b4b994&ts=true"
import script from "./CreateVersion.vue?vue&type=script&lang=ts"
export * from "./CreateVersion.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__